import React, { Suspense, lazy } from 'react'
import { Box, CircularProgress, Dialog, DialogContent } from '@material-ui/core'
import SampleToolDialogTitle from './SampleToolDialogTitle'

// GeneCov (and its charts) load the first time the dialog opens, not with the
// analysis table.
const GeneCov = lazy(() => import('src/views/VariantDashboard/GeneCov'))

// Gene coverage for one sequenced sample, opened from the Home analysis table.
// GeneCov mounts only while the dialog is open.
const GeneCoverageDialog = ({ open, onClose, fileId, sampleLabel }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="xl">
    <SampleToolDialogTitle title="Gene coverage" sampleName={sampleLabel} onClose={onClose} />
    <DialogContent sx={{ height: '80vh', overflowY: 'auto' }}>
      <Suspense
        fallback={
          <Box sx={{ display: 'flex', justifyContent: 'center', pt: 8 }}>
            <CircularProgress size={24} />
          </Box>
        }
      >
        <GeneCov fileId={fileId} />
      </Suspense>
    </DialogContent>
  </Dialog>
)

export default GeneCoverageDialog
